const doc = [({"da":({"js":({"admin":({"logs":({"names":({"activity_participant":({"no_activity_participant":"Ingen deltager"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;